import default_json_messages from "./ask_messages.json";
import {ObjectMap} from "./ObjectMap";



export const objectToMap = <T>(value:any): ObjectMap<T> => {
    if(typeof value === 'object' && value !== null) {
        return (new Map(Object.keys(value).map((k: string) => [k, objectToMap(value[k])])));
    } else return(value);
}

const default_messages:ObjectMap<string> = objectToMap<string>(default_json_messages);

export const getMessage = (key: string, messages: null | ObjectMap<string>):string => {
    const getDefaultMessage = (key: string):string => {
        const default_values_map = (default_messages as Map<string, ObjectMap<string>>)?.get('default') as Map<string, string>;
        const default_nav_map = (default_messages as Map<string, ObjectMap<string>>)?.get(navigator.language) as Map<string, string>;


        if (!default_nav_map) {
            if (!default_values_map.get(key)) {
                return (default_values_map.get('nokey')!);
            }
            return (default_values_map.get(key)!);
        } else {
            if (!default_nav_map.get(key)) {
                if (!default_values_map.get(key)) {
                    return (default_values_map.get('nokey')!);
                }
                return (default_values_map.get(key)!);
            } else {
                return (default_nav_map.get(key)!);
            }
        }
    }

    if (!messages)
        return (getDefaultMessage(key));

    const messages_values_map = (messages as Map<string, ObjectMap<string>>).get('default') as Map<string, string>;
    const messages_nav_map = (messages as Map<string, ObjectMap<string>>).get(navigator.language) as Map<string, string>;

    if (messages && messages_nav_map && messages_nav_map.get(key)) {
        return (messages_nav_map.get(key)!);
    }

    if (messages && messages_values_map && messages_values_map.get(key)) {
        return (messages_values_map.get(key)!);
    }

    return (getDefaultMessage(key));

}
